<template>
  <div class="footerCopyright">
    <div class="container col">
      <div class="row items-center">
        <div class="col s10 m9">
          <div class="footerCopyright__block text-second-800">
            <i class="copy">©</i>&nbsp;
            <span class="copyright">
              {{ new Date().getFullYear() }}
              <NuxtLink
                to="/"
                :aria-label="confMain.siteDescr"
              >
                {{ confMain.siteName }}.&nbsp;
              </NuxtLink>
              {{ $t('allRightsReserved') }}.
            </span>

            <span class="copyright">
              {{ confMain.holdingName }}
            </span>

            <ul class="policyList">
              <li>
                <NuxtLink
                  :aria-label="$t('privacyPolicy')"
                  :to="confNavigation.system.find(n => n.id === 'privacy').link"
                >
                  {{ $t('privacyPolicy') }}
                </NuxtLink>
              </li>
              <li>
                <NuxtLink
                  :aria-label="$t('allRightsReserved')"
                  :to="confNavigation.system.find(n => n.id === 'copyright').link"
                >
                  {{ $t('allRightsReserved') }}
                </NuxtLink>
              </li>
              <li>
                <NuxtLink
                  :aria-label="$t('sitemap')"
                  to="/sitemap"
                >
                  {{ $t('sitemap') }}
                </NuxtLink>
              </li>
            </ul>
          </div>
        </div>
        <div class="col s2 m3">
          <div class="footerCopyright__block right">
            <button
              class="backToTop active btn blue btn-underline flex items-center"
              style="min-width: 100px;"
              :aria-label="$t('scrollBackToTop')"
              @click="scrollTo($event, 'body')"
            >
              <span class="hidden md:block">
                {{ $t('backToTop') }}
              </span>
              <span class="icon icon-arrow-up ml-0 md:ml-2"></span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
const { confMain, confNavigation } = useConfig()
</script>

<style lang="scss">
.footerCopyright {
  align-items: unset;
  overflow: hidden;
  padding: 10px 0;
  font-size: 12px;
  background-color: #f6f7f9;
  &__block {
    display: flex;
    align-items: center;
    .copy {
      display: inline-block;
      font-size: 1rem;
      font-style: normal;
      line-height: 0;
      vertical-align: middle;
    }
    .copyright {
      display: inline-block;
      margin: 0 14px 0 0;
    }
    .policyList {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      margin: 0 -8px;
      color: #015287;
      font-size: 12px;
      font-weight: 400;
      line-height: 1rem;
      li {
        padding: 3px 8px;
      }
    }
    .backToTop {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      font-size: 12px;
      [class^="icon"] {
        margin-left: 8px;
        font-size: 18px;
      }
    }
  }
}
</style>
